const CDN_BASE_URL =
  "https://cdn.jsdelivr.net/gh/CruiseMaster-ME/CruiseMaster-CDN@v1.2.5/assets";
const BASE_URL = "https://cruisemaster-me.com";

export { CDN_BASE_URL, BASE_URL };
